import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Iphone17FrameProps = {
  children: ReactNode;
  className?: string;
  fill?: boolean;
};

export function Iphone17Frame({ children, className, fill = false }: Iphone17FrameProps) {
  return (
    <div
      className={cn(
        "relative mx-auto select-none",
        fill ? "h-full w-full" : "aspect-[9/19.5] w-full max-w-[300px]",
        className,
      )}
    >
      {/* Corpo — overflow visible para nao cortar cantos/sombra */}
      <div
        className={cn(
          "relative h-full w-full rounded-[2.65rem] p-[4px]",
          "bg-gradient-to-b from-[#3a3a3c] via-[#1c1c1e] to-black",
          "shadow-[0_24px_48px_-12px_rgba(0,0,0,0.45)]",
        )}
      >
        <div className="flex h-full w-full flex-col rounded-[2.45rem] bg-[#1c1c1e] p-[2px]">
          <div className="relative h-full w-full overflow-hidden rounded-[2.35rem] bg-black">
            {/* Dynamic Island — sobre a tela */}
            <div
              className="pointer-events-none absolute left-1/2 top-[10px] z-40 h-[24px] w-[78px] -translate-x-1/2 rounded-full bg-black"
              aria-hidden
            />

            {/* Area da tela */}
            <div className="absolute inset-[2px] overflow-hidden rounded-[2.2rem] bg-[#E5DDD5]">
              <div className="relative h-full w-full">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
